// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testDiv {
  height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Testimonials.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ","sourcesContent":[".testDiv{\n    height: 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
